import axios from './axios'

export const getMailboxStat = (params) => {
  return axios({
    url: '/user/self/usage-statistic/mailbox/online/stat/',
    method: 'GET',
    params
  })
}

export const getMailboxOfflineRecords = (params) => {
  return axios({
    url: '/user/self/usage-statistic/mailbox/offline/',
    method: 'GET',
    params
  })
}
